export const Server = {
    endpoint: "https://appwrite.oldbird.run/v1",
    project: "6419979b9f5588daa781",
};
